const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const updateSingleInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_INVOICE_VIEW_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_INVOICE_VIEW_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default updateSingleInvoice;